import { BatchingMethod } from '../../enums/batching-task/batching-method';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a Batching task — groups records or nested array items into
 * fixed-size batches. Each output record has processingData = array (one batch).
 * ByRecord batches whole processingData objects; ByField extracts items from a
 * nested array field. batchSize must be 1–9999; batchAll overrides it.
 */
export class BatchingConfig extends DestinationTaskConfigBase {
	/**
	 * How records are grouped. ByRecord=0 batches whole processingData objects;
	 * ByField=1 reads items from the batchingField array and batches those.
	 * @default BatchingMethod.ByRecord
	 */
	batchingMethod = BatchingMethod.ByRecord;

	/**
	 * Dot-notation path to a nested array within processingData. Required when
	 * batchingMethod=ByField. Must resolve to an array or the task throws.
	 */
	batchingField?: string;

	/**
	 * Number of items per batch as a string. Must parse to 1–9999.
	 * Supports expression syntax. Overridden by batchAll.
	 * @default '10'
	 */
	batchSize = '10';

	/**
	 * When true, all records/items are collected into a single batch. Internally
	 * sets batchSize to the total record count via GETRECORDCOUNT().
	 * @default false
	 */
	batchAll = false;

	constructor(init?: Partial<BatchingConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
